import { IconCodeTextInputModel } from '../icon-code-text-input.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * アイコンコードテキストインプット取得クラス
 *
 * @export GetIconListService
 * @class GetIconListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetIconListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: IconCodeTextInputModel;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetIconListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ArrangeDiv: this.vo.arrangeDiv
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetIconListService
   */
  execute(model: IconCodeTextInputModel, vo: any): void {
    this.model = model;
    this.vo = vo;
    this.send('KYMW02getIconList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetIconListService
   */
  success(data: any): void {
    this.model.updateIconList(data);
  }

}
